import { render, staticRenderFns } from "./LeaveDialog.vue?vue&type=template&id=21121f77"
import script from "./LeaveDialog.vue?vue&type=script&lang=js"
export * from "./LeaveDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports